'use client';

import { useTranslations } from 'next-intl';
import { Currency } from 'utils/Currency';
import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { useGlobalUI } from 'contexts/GlobalUIContext';

import { useCartStore, useShallow } from 'components/shared/Cart';
import { BuyProvider } from 'components/buy';
import {
  PhotonPrice,
  productMap_photon,
  photonCards,
} from 'content/products/photon';
import {
  HeroSection,
  ImageSection,
  WavelengthsSection,
  SkinHealthSection,
  MuscleRecoverySection,
  PowerplugSection,
  ThreeStepsSection,
  PhotonComparison,
  TherapySection,
  ScienceSection,
  EndBannerSection,
} from 'components/photon';
import { jetbrainsMono } from 'utils/fonts';

import styles from './photon-client.module.css';

interface PhotonBuyPageProps {
  currency: Currency;
  store: ShopifyStore;
  countryCode: string;
}

const PhotonBuyPage = ({ currency, store }: PhotonBuyPageProps) => {
  const CartClient = useCartStore(
    useShallow((s) => ({ setStore: s.setStore })),
  );
  CartClient.setStore(store);
  useGlobalUI({ headerCollaspable: true });
  const t = useTranslations('photon');

  return (
    <BuyProvider
      store={store}
      currency={currency}
      productName="Ultrahuman Photon"
      basePrice={PhotonPrice[store]}
      baseVariantId={productMap_photon.variantId[store]}
      cards={photonCards}
    >
      <div className={jetbrainsMono.variable}>
        <HeroSection />
        <ImageSection />
        <ScienceSection />
        <WavelengthsSection />
        <SkinHealthSection />
        <MuscleRecoverySection />
        <TherapySection />
        <PowerplugSection />
        <ThreeStepsSection />
        <PhotonComparison />
        <EndBannerSection />
        <div className={styles.root}>
          <p className={styles.bottomNote}>
            {t('photon.indexPage.text.medicalDisclaimer')}
          </p>
          <div className={styles.noteSeparator} />
        </div>
      </div>
    </BuyProvider>
  );
};

export default PhotonBuyPage;
